import styled from 'styled-components';

export const MainMessageContainerV2 = styled.div`
  margin-bottom: 10px;
`;

export const CheckContainerV2 = styled.div`
  display: flex;
  flex-direction: row;
  
  > label {
    font-size: 12px;
    max-width: 100%;
    line-height: 20px;
  }
`;
